export const ORDER = {
    DESC: 'DESC',
    ASC: 'ASC'
};

export const RESET_FOLDER_FIELD = {
    SORT: 'isSortedDefault'
};

export const UPL_TOASTID_PREFIX = 'upld-doc-';
export const TOAST_STATUS = {
    QUEUED: "action-queued",
    IN_PROGRESS: "action-inprogress",
    FAILED: "action-failed",
    PROCESSING: "action-processing",
    COMPLETE: "action-completed",
    WARNING: "action-warning"
};

export const FOLDER_MODULES = {
    DISCUSSION: 'DISCUSSION',
    DOCUMENT: 'DOCUMENT',
    RESOURCE_LIBRARY: 'RESOURCE_LIBRARY'
};
export const NULL_TEXT = '-- None --';
export const FORMS_MODULE = 'forms';
export const ORGANIZE_MODULE = 'organize';
export const convertibleTypes = [
    "doc",
    "docx",
    "xls",
    "xlsx",
    "ppt",
    "pptx",
    "rtf",
    "pdf",
    "odt",
    "odp",
    "ods",
];

export const MODULE_ACTIONS = {
    ALL: 'ALL',
    SHOW: 'SHOW',
    CREATE: 'CREATE'
};
export const MODULES = {
    DISCUSSION: 'DISCUSSION',
    COVERSHEET: 'COVERSHEET',
    LOGO: 'LOGO',
    SUBJECT: 'SUBJECT'
};
export const MODULES_DEFAULT = {
    DISCUSSION: true,
    COVERSHEET: false,
    LOGO: false
};
export const MENU_ACTIONS = {
    CREATE: "create",
    OPEN: "open",
    RENAME: "rename",
    MOVE: "move",
    COPY: "copy",
    EDIT: "edit",
    DELETE: "delete",
    SHARE: "share",
    VIEW_FORM: "viewForm",
    VIEW: "view",
    SELECT: "select",
    FILL_OUT: "fillOut",
    ASSIGN_TEAM: "assignTeam",
    BEGIN_DETERMINATION: "beginDetermination",
    ASSIGN_SERVICE: "assignService",
    DOWNLOAD: "download",
    EDIT_DESCRIPTION: "editDescription",
    SHAREABLE_LINK: "shareableLink",
    SIGNATURE: "signature",
    SET_UP_SIGN: "setupSign",
    APPLY_TEMPLATE: "applyTemplate",
    REVIEW_SIGN: "reviewSign",
    SIGN_DOC: "signDocument",
    DOWNLOAD_SIGN: "downloadSign",
    SEND_REMINDER: "sendReminder",
    SUBMIT: "submit",
    MANAGE_MEMBERS: "manageMembers",
    EDIT_TEAM_INFO: "editTeamInfo",
    FREEZE_TEAM: "freezeTeam",
    GET_COVER_SHEET: "getCoverSheet",
    TRANSFER_OWNERSHIP: "transferOwnership",
    MANAGE_CARE_RECIPIENTS: "manageCareRecipients",
    DEACTIVATE: "deactivate",
    ADD_TO_TEAMS: "bulkAddUser",
    REMOVE_FROM_TEAMS: "bulkRemoveUser",
    IMPORTANT: "markAsImportant",
    UNIMPORTANT: "markAsUnimportant",
    READ: "markAsRead",
    REGENERATE_SUMMARY: "regenerateSummary",
};
export const TEAMS_FILTER = 'filterTeamsBy';

export const SIGNATURE_FLOW = {
    SETUP: "SETUP",
    SIGNING: "SIGNING",
    REVIEW: "REVIEW",
    APPLY_TEMPLATE: "APPLY_TEMPLATE",
    REVIEW_APPLIED_TEMPLATE: "REVIEW_APPLIED_TEMPLATE",
};

export const SIGNATURE_FLOW_UNITS = {
    SETUP_SIGN: 1,
    REVIEW: 2,
    APPLY_TEMPLATE: 4,
    DOWNLOAD_SIGNED_TEMPLATE: 8,
    ASSIGNED_TO_SIGN: 16,
    SIGNED: 32,
};

/**
 * Constants and interfaces for organization
 * and system login messages
 */

export const MESSAGE_TYPE = {
    ORG: 'ORG' as const,
    ECV: 'ECV' as const
};

export interface ILoginMessage {
    type: typeof MESSAGE_TYPE.ORG
        | typeof MESSAGE_TYPE.ECV;
    orgName: string;
    message: string;
    lastUpdatedAt: string;
}

export interface IMessageResponse {
    messages: ILoginMessage[];
}

export const APP_URLS = {
    // --- "Get App" banner (mobile/tablet responsive view only) ---
    IOS_APP_STORE_URL: 'https://apps.apple.com/in/app/ecare-vault-mobile-app/id6475713121',
    ANDROID_PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=com.ecarevault.mobile'
};
